import { render, staticRenderFns } from "./ProposalDetailed.vue?vue&type=template&id=5b1553c0&scoped=true&"
import script from "./ProposalDetailed.vue?vue&type=script&lang=js&"
export * from "./ProposalDetailed.vue?vue&type=script&lang=js&"
import style0 from "./ProposalDetailed.vue?vue&type=style&index=0&id=5b1553c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1553c0",
  null
  
)

export default component.exports